<template>
  <ms-button
    :ref="`toolbarButton${propsData.styleName}`"
    type="secondary-outline"
    :class="['toolbar-workbook-button', {active: isStyled}]"
    :title="propsData.toolTip"
    :left-icon="propsData.icon || ''"
    @click="clickButton"
  />
</template>

<script>
import {computed, ref} from 'vue';
export default {
  name: 'toolbarItemButton',
  props: {
    /**
     * Đối tượng toolbar
     */
    propsData: {
      type: Object,
      default: {},
    },
    /**
     * style của range đang focus
     */
    rangeStyle: {
      type: Object,
      default: {},
    },
  },
  emits: ['toolbarEvent'],
  setup(props, {emit}) {
    const isActive = ref(false);
    /**
     * Hàm trả style ra ngoài
     * TMNghia 30/03/2024
     */
    const clickButton = event => {
      emit('toolbarEvent', event, 'click', {toolbar: props.propsData, value: null});
    };

    /**
     * Hàm bind style lên toolbar
     * TMNghia 30/03/2024
     */
    const isStyled = computed(() => {
      if (isActive.value) {
        setActive();
        return isActive.value;
      }
      let styleName = props.propsData.styleName,
        styleValue = props.propsData.styleValue;
      if (styleName && props.rangeStyle[styleName] === styleValue) {
        setActive();
        return true;
      }

      setInactive();
      return false;
    });    
    /**
     * Active button
     * TMNghia 02/04/2024
     */
    const setActive = () => {
      if (!props.propsData.icon.includes(' toolbar-active')) {
        props.propsData.icon += ' toolbar-active';
      }
    };
    /**
     * Inactive button
     * TMNghia 02/04/2024
     */
    const setInactive = () => {
      props.propsData.icon = props.propsData.icon.replace(' toolbar-active', '');
    };

    return {
      clickButton,
      isStyled,
      isActive,
    };
  },
};
</script>

<style lang="scss">
.toolbar-workbook-button {
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  &.active {
    background-color: $button-secondary-outline-hover-bg !important;
  }
}
</style>